module.exports = __webpack_public_path__ + "img/MEDIA047.2e17eb4b.jpg";